var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPinFilled = function SvgPinFilled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1523 3.57693C13.9199 2.34449 11.8126 3.21735 11.8126 4.96028C11.8126 5.47914 11.6065 5.97674 11.2396 6.34363L9.61887 7.96433C9.25198 8.33122 8.75438 8.53733 8.23552 8.53733C6.49259 8.53733 5.61972 10.6446 6.85216 11.877L9.22844 14.2533L3.71088 19.7709C3.42971 20.0521 3.42971 20.5079 3.71088 20.7891C3.99206 21.0703 4.44794 21.0703 4.72912 20.7891L10.2467 15.2716L12.6229 17.6478C13.8554 18.8802 15.9626 18.0074 15.9626 16.2645C15.9626 15.7456 16.1688 15.248 16.5357 14.8811L18.1564 13.2604C18.5232 12.8935 19.0209 12.6874 19.5397 12.6874C21.2826 12.6874 22.1555 10.5801 20.9231 9.34768L15.1523 3.57693Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPinFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "pin-filled.e3ac79596887cea68329895a5cc2f33a.svg";